import React, { useEffect, useContext, useState, Fragment } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import useLogicForm from '../../hooks/useLogicForm';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Spinner } from 'react-bootstrap';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';
import { Modal } from 'react-bootstrap';
import { alertService } from '../../services/alertservice';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import { Alert } from '../../componentes/ui/Alert';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Kpi from '../../componentes/ui/Kpi';
import MiDataTable from '../../componentes/ui/MiDataTable';
import FormInput from '../../componentes/formulario/FormInput';
import FormRow from '../../componentes/formulario/FormRow';
import MiDataTableLarge from './MiDataTableLarge';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import Button from '../../componentes/ui/Button';
import MiSelect from '../../componentes/formulario/MiSelect';
import TextArea from '../../componentes/formulario/TextArea';
import { getApiUrl, axiosPost, encryptData, getAhorayyyymmdd, getDecodedCookie, getTitle } from '../../helpers/helperApp';

$.DataTable = DataTable;

function LargeInv(props) {

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
   
    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom, tipDocInv, centroActivo } = useContext(LoginContext);

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg } = useLogicForm()    

    const [ confPantalla, saveConfPantalla ] = useState(confApp);
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ docSeleccionado, saveDocSeleccionado ] = useState(null);
    const [ idFiltro, saveIdFiltro ] = useState(tipDocInv);
    const [ documentos, saveDocumentos ] = useState([]);
    const [ reloadKpi, saveReloadKpi ] = useState(0);
    const [ loading, saveLoading ] = useState(false);
    const [ lineas, saveLineas ] = useState([]);
    const [ unidad, saveUnidad ] = useState({value: 0, label: ""});
    const [ cantidad, saveCantidad ] = useState(0);
    const [ ubicacion, saveUbicacion ] = useState({value: 0, label: ""});
    const [ showModalEditCabecera, saveShowModalEditCabecera ] = useState(false);
    const [ idestCab, saveIdEstCab ] = useState();
    const [ nom1Cab, saveNom1Cab ] = useState();
    const [ nom1EnCab, saveNom1EnCab ] = useState();
    const [ fec1Cab, saveFec1Cab ] = useState();
    const [ fec2Cab, saveFec2Cab ] = useState();
    const [ fec3Cab, saveFec3Cab ] = useState();
    const [ notasCab, saveNotasCab ] = useState();
    const [ notasEnCab, saveNotasEnCab ] = useState();
    const [ loadingActionModal, saveLoadingActionModal ] = useState(false);
    const [ showModalEditLinea, saveShowModalEditLinea ] = useState(false);
    const [ idLin, saveIdLin ] = useState();
    const [ idestLin, saveIdEstLin ] = useState();
    const [ num3Lin, saveNum3Lin ] = useState();
    const [ nom1Lin, saveNom1Lin ] = useState();
    const [ nom1EnLin, saveNom1EnLin ] = useState();
    const [ fec1Lin, saveFec1Lin ] = useState();
    const [ fec2Lin, saveFec2Lin ] = useState();
    const [ fec3Lin, saveFec3Lin ] = useState();
    const [ notasLin, saveNotasLin ] = useState();
    const [ notasEnLin, saveNotasEnLin ] = useState();
    const [ showModalNewInv, saveShowModalNewInv ] = useState(false);    
    const [ idSelectPInv, saveIdSelectPInv ] = useState(0);
    const [ idCentro, saveIdCentro ] = useState(0);
    const [ docBloqueado, saveDocBloqueado ] = useState(false);

     useEffect( () => {                
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                     
                    document.title = getTitle(confPantalla.config.trad, confPantalla.largeinv.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);                                                
                        saveIdFiltro(tipDocInv);                            
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 
    },[confPantalla])

    const handleGetLineas = async (idRowSeleccionado, idTabla, datosTabla, docTablaSeleccionado) => { 
        
        if(docTablaSeleccionado.length > 0){

            docTablaSeleccionado && docTablaSeleccionado[0] && docTablaSeleccionado[0].idest == 9 ? saveDocBloqueado(true) : saveDocBloqueado(false);

            // Seleccionar documento en la tabla
            saveLoading(true);

            saveDocSeleccionado(docTablaSeleccionado[0]);

            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", JSON.stringify(docTablaSeleccionado[0].id));
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largeinv.controles.datatableres.getdata, data, source.token);            
            if( typeof respuesta.data !== "string" ){                               
                saveLineas(respuesta.data);                
            }else if( typeof respuesta.data === "string" ){            
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
            } 
            saveLoading(false);
        }else{
            // Quitar selección
            saveLineas([]);
            saveDocSeleccionado(null);
            saveDocBloqueado(false)
        }

    }

    //***** AÑADIR LINEA *****//
    const addLinea = async() => {
        if( unidad != 0 ){
            // Editar documento
            saveLoading(true);                 
            accionesDoc(docSeleccionado.id, idFiltro, unidad, cantidad, ubicacion, "modificar")             
        }else{
            // Error. Debe seleccionar una unidad            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.largeinv.errorunidad.title}`, {autoClose: false});
        }
    }

    const accionesDoc = async (idDocActual, idFiltro, unidad, cantidad, ubicacion, accion) => {
        const data = new FormData();       
        data.append("validacion", apiKey());
        data.append("iddoc", idDocActual); 
        data.append("tipdoc", idFiltro); 
        data.append("iduni", unidad.value); 
        data.append("num1", cantidad); 
        data.append("idubi", ubicacion.value);
        data.append("accion", accion)                    
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/edirap/actionsedirap', data);
        saveLoading(false);       
        if( typeof respuesta.data !== "string" ){           
            saveUnidad({value: 0, label: ""});
            saveCantidad(0);
            saveUbicacion({value: 0, label: ""});            
            const editedDoc = await reloadDoc(respuesta.data.idClon);
            if(editedDoc){
                await handleGetLineas(`#row-${editedDoc.id}`, "edirap", documentos, [{id : docSeleccionado.id}]);                         
                saveDocSeleccionado(editedDoc);                    
            }                  
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.largeinv.linesuccess.title}`, {autoClose: true}); 
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        } 
    }

    //***** NUEVA OPERACION *****//
    const handleNewInv = () => {
        saveShowModalNewInv(true);
        saveIdCentro(centroActivo != "" ? centroActivo : 0);
        saveIdSelectPInv(0);
        saveFec1Cab(getAhorayyyymmdd()+" 00:00");
        saveNom1Cab("");
        saveNom1EnCab("");
    }
    
    const accionNew = async () => {
        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idplan", idSelectPInv);
        data.append("idcen", idCentro);
        data.append("fec1", fec1Cab); 
        data.append("nom1", nom1Cab);            
        data.append("nom1_en", nom1EnCab);                
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largeinv.controles.modalnew.new.senddata, data, source.token);        
        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});  
        }else{
            saveUnidad(0);
            saveCantidad(0);
            saveUbicacion(0);                      
            saveReloadKpi(reloadKpi+1);            
            const editedDoc = await reloadDoc(respuesta.data.idClon);    
            if(editedDoc){
                await handleGetLineas(`#row-${editedDoc.id}`, "edirap", documentos, [editedDoc]);
                saveDocSeleccionado(editedDoc);
            }              
        }
        
        saveLoadingActionModal(false);
        saveShowModalNewInv(false);
    }


    //***** EDITAR CABECERA *****//
    const btnEditCabecera = (e) => {
        e.preventDefault();        
        saveIdEstCab(docSeleccionado.idest);
        saveFec1Cab(docSeleccionado.fec1);
        saveFec2Cab(docSeleccionado.fec2);
        saveFec3Cab(docSeleccionado.fec3);
        saveNom1Cab(docSeleccionado.nom1);
        saveNom1EnCab(docSeleccionado.nom1_en);
        saveNotasCab(docSeleccionado.notas);
        saveNotasEnCab(docSeleccionado.notas_en);
        saveShowModalEditCabecera(true);
    }
    
    const accionBtnEditCabecera = async () => {

        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("id", docSeleccionado.id);
        data.append("idest", idestCab);            
        data.append("fec1", fec1Cab);
        data.append("fec2", fec2Cab);
        data.append("fec3", fec3Cab);
        data.append("nom1", nom1Cab);
        data.append("nom1_en", nom1EnCab);
        data.append("notas", notasCab);
        data.append("notas_en", notasEnCab);
        data.append("origen", "/largecomp");
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largeinv.controles.modaleditcabecera.updatecabecera.senddata, data, source.token);
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            const editedDoc = await reloadDoc();
            if(editedDoc){
                saveDocSeleccionado(editedDoc);
            }
            saveReloadKpi(reloadKpi+1);             
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.largeinv.controles.modaleditcabecera.updatecabecera.success.title}`, {autoClose: true});
        }  

        saveLoadingActionModal(false);
        saveShowModalEditCabecera(false);
    }

    //***** EDITAR LINEAS *****//
    const btnEditLinea = (e, rowData) => {        
        saveIdLin(rowData.id);
        saveIdEstLin(rowData.idest);
        saveNum3Lin(rowData.coste);
        saveFec1Lin(rowData.fec1);
        saveFec2Lin(rowData.fec2);
        saveFec3Lin(rowData.fec3);
        saveNom1Lin(rowData.descripcionlin);
        saveNom1EnLin(rowData.descripcionlin_en);
        saveNotasLin(rowData.notas);
        saveNotasEnLin(rowData.notas_en);
        saveShowModalEditLinea(true);
    }

    const accionBtnEditLinea = async () => {

        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("id", idLin);        
        data.append("idest", idestLin);
        data.append("num3", num3Lin);
        data.append("fec1", fec1Lin);
        data.append("fec2", fec2Lin);
        data.append("fec3", fec3Lin);
        data.append("nom1", nom1Lin);
        data.append("nom1_en", nom1EnLin);
        data.append("notas", notasLin);
        data.append("notas_en", notasEnLin);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.largeinv.controles.modaleditlinea.updatelinea.senddata, data, source.token);
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            const editedDoc = await reloadDoc();
            await handleGetLineas(`#row-${docSeleccionado.id}`, "edirap", documentos, [editedDoc]);            
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.largeinv.controles.modaleditlinea.updatelinea.success.title}`, {autoClose: true});
        }  

        saveLoadingActionModal(false);
        saveShowModalEditLinea(false);
    }

    const reloadDoc = async (idDoc=null) => {
        
        let reloadedDoc = [];

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idFiltro", idFiltro);
        data.append("idparam", idDoc == null ? docSeleccionado.id : idDoc);            
        data.append("reloaddoc", true);                
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+"/edirap/getdocumentosedirap", data, source.token);        
        if( typeof respuesta.data !== "string"){
            reloadedDoc = respuesta.data[0];
        }

        return reloadedDoc;
        
    }


    //***** HANDLES *****//
    const handleCantidad = (e) => {
        const { name, value } = e.target;
        saveCantidad(value)        
    }

    const handleSelectModal = (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInputModal = (e, save) => {        
        save(e.target.value)
    }

    return (
        <div className="App wrapper">
            <div>
                {loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div>
                    :
                    null
                }
            </div>
            {
                confPantalla !== undefined
                    ?
                    <Fragment>
                        <Alert fondo={true} />
                        <Menusup
                            props={props}
                        />
                        <Sidebar
                            props={props}
                        />
                    </Fragment>
                    :
                    null
            }
            <div className="content-wrapper">
                <div className="content-header">
                </div>
                <section className="content">
                    {
                        !tieneNivel
                            ?
                            <PermissionRefused
                                traduction={confPantalla.config.trad.components.permissionrefused}
                            />
                            :
                            <Fragment>
                                {
                                loadedConf === true && confPantalla !== undefined
                                    ?
                                    <Section
                                        tituloenhtml={true}
                                        titulo={
                                            docSeleccionado == null
                                                ?
                                                confPantalla.largeinv.section.titulo
                                                :
                                                docSeleccionado.nomdoc
                                        }
                                        icono={confPantalla.largeinv.section.icono}
                                        col={confPantalla.largeinv.section.col}
                                        formulario={ {id: docSeleccionado != null ? docSeleccionado.id : null} }
                                        idPrin={docSeleccionado != null ? docSeleccionado.id : null }
                                        borderHeader={docSeleccionado != null ? docSeleccionado.color : null}
                                        recurrencia={docSeleccionado != null ? docSeleccionado.recurrencia : null}
                                        editCabEdirap={btnEditCabecera}
                                        idDocGoToRunCicCfg={docSeleccionado != null ? docSeleccionado.id : 0}
                                        infoDocActual={docSeleccionado}
                                        informes={confPantalla.largeinv.controles.informes}
                                        docBloqueado={docBloqueado}
                                        origen={"largeinv"}
                                    >
                                        <Kpi
                                            conf={ confPantalla.largeinv.controles.kpi }
                                            getDataTable1 = { confPantalla.largeinv.controles.datatable.getdata }
                                            saveDataTable1 = { saveDocumentos }                           
                                            saveLoadingTable = { saveLoading }
                                            filtro={ confPantalla.largeinv.controles.kpi.tipdoc }
                                            idFiltro={ idFiltro }                                           
                                            forceReload={props.location.state ? null : reloadKpi}
                                            readOnlyFiltro={"readonly"}
                                        />
                                        <MiDataTable 
                                            estadoForm= { "" }
                                            formulario={ {id:0} }
                                            id={"docLargeInv"}
                                            columnas={confPantalla.largeinv.controles.datatable.columns}
                                            data={documentos}
                                            buttons={confPantalla.largeinv.controles.datatable.buttons}
                                            ordering={confPantalla.largeinv.controles.datatable.ordering}
                                            order={confPantalla.largeinv.controles.datatable.order}
                                            searching={confPantalla.largeinv.controles.datatable.searching}
                                            paging={confPantalla.largeinv.controles.datatable.paging}
                                            select={confPantalla.largeinv.controles.datatable.select}
                                            pagelength={confPantalla.largeinv.controles.datatable.pagelength}                                            
                                            // loadingTable={loading}
                                            columnactions={confPantalla.largeinv.controles.datatable.columnactions.title}
                                            linkColumns={confPantalla.largeinv.controles.datatable.linkColumns}
                                            traduction={confPantalla.config.trad.components.datatable}                                            
                                            functionAfterSelect={handleGetLineas}
                                            selectIds={docSeleccionado != null ? docSeleccionado.id : ""}
                                            selectIdsKeySearch={"id"}
                                        />
                                        {
                                            docSeleccionado == null
                                            ?
                                                <div className='text-center'>
                                                    <Button 
                                                        clases={ "col-5 mt-2 mb-4" }
                                                        estadoForm={ false }
                                                        color={ "primary" }  
                                                        type="button" 
                                                        icono={ "" }   
                                                        id="btncreateinv"     
                                                        texto={ confPantalla.largeinv.btncreateinv.title }   
                                                        accion={ handleNewInv } 
                                                        disabled={ false }
                                                    /> 
                                                </div>
                                            :
                                                null
                                        }
                                        <FormRow clases={"formedirap"}>                                            
                                            {/* <h4 className='col-12'>{docSeleccionado == null ? confPantalla.largeinv.modocreacion.title :  confPantalla.largeinv.modoedicion.title}</h4> */}
                                            <MiSelectLarge
                                                value={unidad}
                                                saveValue={saveUnidad}                                                
                                                label={confPantalla.largeinv.controles.iduni.label.title}
                                                col={4}
                                                confPantalla={confPantalla}
                                                dataType={confPantalla.largeinv.controles.iduni.datatype}
                                                dataSql={confPantalla.largeinv.controles.iduni.data}
                                                multiLinea={confPantalla.largeinv.controles.iduni.multilinea} 
                                                readOnly={docBloqueado == true || docSeleccionado == null ? true : false} 
                                            />
                                            <FormInput 
                                                estadoForm= { "" }
                                                value=      { cantidad }
                                                loading=    { loadReg ? true : false }
                                                id=         { confPantalla.largeinv.controles.num1.id }   
                                                type=       { confPantalla.largeinv.controles.num1.type }  
                                                name=       { confPantalla.largeinv.controles.num1.name }   
                                                label=      { confPantalla.largeinv.controles.num1.label }                                                       
                                                placeholder={ confPantalla.largeinv.controles.num1.placeholder }    
                                                col=        { confPantalla.largeinv.controles.num1.col } 
                                                required=   { confPantalla.largeinv.controles.num1.required }
                                                readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.num1.readonly }                                                
                                                disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.num1.disabled }
                                                alignRight= { confPantalla.largeinv.controles.num1.alignRight }
                                                change=     { handleCantidad }
                                                onBlur=     {null} 
                                            />
                                            <MiSelectLarge
                                                value={ubicacion}
                                                saveValue={saveUbicacion}                                                
                                                label={confPantalla.largeinv.controles.idubi.label.title}
                                                col={4}
                                                confPantalla={confPantalla}
                                                dataType={confPantalla.largeinv.controles.idubi.datatype}
                                                dataSql={confPantalla.largeinv.controles.idubi.data}
                                                multiLinea={confPantalla.largeinv.controles.idubi.multilinea}
                                                unidad={unidad}
                                                minCharSearch={0}
                                                readOnly={docBloqueado == true || docSeleccionado == null ? true : false}
                                            />
                                            <button 
                                                style={{marginTop: "32px"}} 
                                                id="btnaddline"
                                                className={"btn btn-flat btn-outline-success col-md-2 col-sm-12 mb-4" } 
                                                type="button" 
                                                onClick={ addLinea } 
                                                disabled={ docBloqueado == true || docSeleccionado == null ? true : false }
                                            >
                                                <i className="fal fa-plus"></i>
                                                {confPantalla.largeinv.controles.btnaddline.title}
                                            </button>                                         
                                        </FormRow>  

                                        {   loading ? 
                                                // <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                                //     <Spinner animation="border" />
                                                // </div>
                                                <SpinnerFloat  />
                                            :
                                            null
                                        }
                                        {
                                        lineas != null
                                        ?
                                            <MiDataTableLarge 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"lineasLargeInv"}
                                                columnas={confPantalla.largeinv.controles.datatableres.columns}
                                                data={lineas}
                                                saveData={saveLineas}
                                                buttons={confPantalla.largeinv.controles.datatableres.buttons}
                                                ordering={confPantalla.largeinv.controles.datatableres.ordering}
                                                order={confPantalla.largeinv.controles.datatableres.order}
                                                searching={confPantalla.largeinv.controles.datatableres.searching}
                                                paging={confPantalla.largeinv.controles.datatableres.paging}
                                                select={confPantalla.largeinv.controles.datatableres.select}
                                                pagelength={confPantalla.largeinv.controles.datatableres.pagelength}                                                
                                                columnactions={confPantalla.largeinv.controles.datatableres.columnactions.title}
                                                linkColumns={confPantalla.largeinv.controles.datatableres.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                selectUbi={confPantalla.largeinv.controles.idubi}
                                                selectUni={confPantalla.largeinv.controles.iduni}
                                                inputNum1={confPantalla.largeinv.controles.num1}
                                                swaldelete={confPantalla.largeinv.swaldelete}  
                                                optionSelectUbi={[]} 
                                                optionSelectUni={[]}
                                                idFiltro={idFiltro}
                                                editar={btnEditLinea}
                                                importexcel={true}
                                                confPantalla={confPantalla} 
                                                docBloqueado={docBloqueado}                                           
                                            />        
                                        :
                                            null
                                        }

                                    </Section>                                    
                                    :
                                    <LoadingPage />
                                }
                            </Fragment>

                    }
                    {
                    showModalNewInv == true
                    ?
                    <Modal
                        show={showModalNewInv}
                        onHide={ () => saveShowModalNewInv(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.largeinv.controles.modalnew.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idCentro  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.largeinv.controles.modalnew.idcen.id }    
                                    name=        { confPantalla.largeinv.controles.modalnew.idcen.name }   
                                    label=       { confPantalla.largeinv.controles.modalnew.idcen.label }    
                                    placeholder= { confPantalla.largeinv.controles.modalnew.idcen.placeholder }
                                    col=         { confPantalla.largeinv.controles.modalnew.idcen.col } 
                                    isClearable= { confPantalla.largeinv.controles.modalnew.idcen.isclearable }
                                    isSearchable={ confPantalla.largeinv.controles.modalnew.idcen.issearchable }
                                    dataType=    { confPantalla.largeinv.controles.modalnew.idcen.datatype }
                                    data=        { confPantalla.largeinv.controles.modalnew.idcen.data }
                                    required=    { confPantalla.largeinv.controles.modalnew.idcen.required } 
                                    disabled=  { confPantalla.largeinv.controles.modalnew.idcen.disabled }
                                    readOnly =   { confPantalla.largeinv.controles.modalnew.idcen.readonly }
                                    disablethisid={confPantalla.largeinv.controles.modalnew.idcen.disablethisid}
                                    disableids={confPantalla.largeinv.controles.modalnew.idcen.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdCentro) }
                                    selectDirectIfOneOption={true}
                                    saveValSelect={saveIdCentro}
                                />
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idSelectPInv  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.largeinv.controles.modalnew.plantillas.id }    
                                    name=        { confPantalla.largeinv.controles.modalnew.plantillas.name }   
                                    label=       { confPantalla.largeinv.controles.modalnew.plantillas.label }    
                                    placeholder= { confPantalla.largeinv.controles.modalnew.plantillas.placeholder }
                                    col=         { confPantalla.largeinv.controles.modalnew.plantillas.col } 
                                    isClearable= { confPantalla.largeinv.controles.modalnew.plantillas.isclearable }
                                    isSearchable={ confPantalla.largeinv.controles.modalnew.plantillas.issearchable }
                                    dataType=    { confPantalla.largeinv.controles.modalnew.plantillas.datatype }
                                    data=        { confPantalla.largeinv.controles.modalnew.plantillas.data }
                                    required=    { confPantalla.largeinv.controles.modalnew.plantillas.required } 
                                    disabled=  { confPantalla.largeinv.controles.modalnew.plantillas.disabled }
                                    readOnly =   { confPantalla.largeinv.controles.modalnew.plantillas.readonly }
                                    disablethisid={confPantalla.largeinv.controles.modalnew.plantillas.disablethisid}
                                    disableids={confPantalla.largeinv.controles.modalnew.plantillas.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdSelectPInv) }
                                />                             
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.fec1.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.fec1.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.fec1.name }   
                                    label=      { confPantalla.largeinv.controles.modalnew.fec1.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.fec1.placeholder }    
                                    col=        { 3 } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.fec1.required }
                                    readonly=   { confPantalla.largeinv.controles.modaleditcabecera.fec1.readonly }
                                    disabled=   { confPantalla.largeinv.controles.modaleditcabecera.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Cab) }
                                    onBlur=     {null} 
                                />
                                
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.nom1.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.nom1.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.nom1.name }   
                                    label=      { confPantalla.largeinv.controles.modalnew.nom1.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.nom1.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.nom1.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.nom1.required }
                                    readonly=   { confPantalla.largeinv.controles.modaleditcabecera.nom1.readonly }                                                
                                    disabled=   { confPantalla.largeinv.controles.modaleditcabecera.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.name }   
                                    label=      { confPantalla.largeinv.controles.modalnew.nom1_en.label}                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.nom1_en.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.required }
                                    readonly=   { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.readonly }                                                
                                    disabled=   { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>                           
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }
                            <p className="font-italic text-center">{ confPantalla.largeinv.controles.modalnew.required.title }</p>                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionNew }
                                        disabled={idCentro == 0 || idSelectPInv == 0 || fec1Cab == "" || nom1Cab == "" || loadingActionModal == true ? true : false}
                                >
                                    {confPantalla.largeinv.controles.modalnew.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalNewInv(false) }                                        
                                >
                                    {confPantalla.largeinv.controles.modalnew.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                    }
                    {
                    showModalEditCabecera == true
                    ?
                    <Modal
                        show={showModalEditCabecera}
                        onHide={ () => saveShowModalEditCabecera(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.largeinv.controles.modaleditcabecera.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idestCab  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.largeinv.controles.modaleditcabecera.idest.id }    
                                    name=        { confPantalla.largeinv.controles.modaleditcabecera.idest.name }   
                                    label=       { confPantalla.largeinv.controles.modaleditcabecera.idest.label }    
                                    placeholder= { confPantalla.largeinv.controles.modaleditcabecera.idest.placeholder }
                                    col=         { confPantalla.largeinv.controles.modaleditcabecera.idest.col } 
                                    isClearable= { confPantalla.largeinv.controles.modaleditcabecera.idest.isclearable }
                                    isSearchable={ confPantalla.largeinv.controles.modaleditcabecera.idest.issearchable }
                                    dataType=    { confPantalla.largeinv.controles.modaleditcabecera.idest.datatype }
                                    data=        { confPantalla.largeinv.controles.modaleditcabecera.idest.data }
                                    required=    { confPantalla.largeinv.controles.modaleditcabecera.idest.required } 
                                    disabled=  { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.idest.disabled }
                                    readOnly =   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.idest.readonly }
                                    disablethisid={confPantalla.largeinv.controles.modaleditcabecera.idest.disablethisid}
                                    disableids={confPantalla.largeinv.controles.modaleditcabecera.idest.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdEstCab) }
                                /> 
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.fec1.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.fec1.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.fec1.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.fec1.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.fec1.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.fec1.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.fec1.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.fec1.readonly }
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec2Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.fec2.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.fec2.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.fec2.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.fec2.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.fec2.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.fec2.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.fec2.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.fec2.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.fec2.disabled }
                                    change=     { e => handleInputModal(e, saveFec2Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec3Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.fec3.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.fec3.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.fec3.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.fec3.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.fec3.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.fec3.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.fec3.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.fec3.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.fec3.disabled }
                                    change=     { e => handleInputModal(e, saveFec3Cab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.nom1.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.nom1.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.nom1.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.nom1.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.nom1.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.nom1.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.nom1.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.nom1.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.nom1_en.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.nom1_en.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.nom1_en.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.notas.id }   
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.notas.name }
                                    rows=       { confPantalla.largeinv.controles.modaleditcabecera.notas.rows }      
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.notas.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.notas.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.notas.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.notas.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.notas.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.notas.disabled }
                                    change=     { e => handleInputModal(e, saveNotasCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasEnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditcabecera.notas_en.id }   
                                    name=       { confPantalla.largeinv.controles.modaleditcabecera.notas_en.name }
                                    rows=       { confPantalla.largeinv.controles.modaleditcabecera.notas_en.rows }      
                                    label=      { confPantalla.largeinv.controles.modaleditcabecera.notas_en.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditcabecera.notas_en.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditcabecera.notas_en.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditcabecera.notas_en.required }
                                    readonly=   { docBloqueado == true || docSeleccionado == null ? "readonly" : confPantalla.largeinv.controles.modaleditcabecera.notas_en.readonly }                                                
                                    disabled=   { docBloqueado == true || docSeleccionado == null ? "disabled" : confPantalla.largeinv.controles.modaleditcabecera.notas_en.disabled }
                                    change=     { e => handleInputModal(e, saveNotasEnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditCabecera }
                                        disabled={ docBloqueado == true ? true : false}                                       
                                >
                                    {confPantalla.largeinv.controles.modaleditcabecera.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditCabecera(false) }                                        
                                >
                                    {confPantalla.largeinv.controles.modaleditcabecera.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                    {
                    showModalEditLinea == true
                    ?
                    <Modal
                        show={showModalEditLinea}
                        onHide={ () => saveShowModalEditLinea(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.largeinv.controles.modaleditlinea.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idestLin  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.largeinv.controles.modaleditlinea.idest.id }    
                                    name=        { confPantalla.largeinv.controles.modaleditlinea.idest.name }   
                                    label=       { confPantalla.largeinv.controles.modaleditlinea.idest.label }    
                                    placeholder= { confPantalla.largeinv.controles.modaleditlinea.idest.placeholder }
                                    col=         { confPantalla.largeinv.controles.modaleditlinea.idest.col } 
                                    isClearable= { confPantalla.largeinv.controles.modaleditlinea.idest.isclearable }
                                    isSearchable={ confPantalla.largeinv.controles.modaleditlinea.idest.issearchable }
                                    dataType=    { confPantalla.largeinv.controles.modaleditlinea.idest.datatype }
                                    data=        { confPantalla.largeinv.controles.modaleditlinea.idest.data }
                                    required=    { confPantalla.largeinv.controles.modaleditlinea.idest.required } 
                                    disabled=  { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.idest.disabled }
                                    readOnly =   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.idest.readonly }
                                    disablethisid={confPantalla.largeinv.controles.modaleditlinea.idest.disablethisid}
                                    disableids={confPantalla.largeinv.controles.modaleditlinea.idest.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdEstLin) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { num3Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.num3.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditlinea.num3.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.num3.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.num3.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.num3.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.num3.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.num3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.num3.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.num3.disabled }
                                    change=     { e => handleInputModal(e, saveNum3Lin) }
                                    onBlur=     {null}
                                    alignRight= { true } 
                                /> 
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.fec1.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditlinea.fec1.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.fec1.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.fec1.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.fec1.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.fec1.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.fec1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.fec1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec2Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.fec2.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditlinea.fec2.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.fec2.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.fec2.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.fec2.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.fec2.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.fec2.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.fec2.readonly }                                                
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.fec2.disabled }
                                    change=     { e => handleInputModal(e, saveFec2Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec3Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.fec3.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditlinea.fec3.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.fec3.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.fec3.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.fec3.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.fec3.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.fec3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.fec3.readonly }                                                
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.fec3.disabled }
                                    change=     { e => handleInputModal(e, saveFec3Lin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.nom1.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditlinea.nom1.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.nom1.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.nom1.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.nom1.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.nom1.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.nom1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.nom1.readonly }                                                
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.nom1_en.id }   
                                    type=       { confPantalla.largeinv.controles.modaleditlinea.nom1_en.type }  
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.nom1_en.name }   
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.nom1_en.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.nom1_en.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.nom1_en.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.nom1_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.nom1_en.readonly }                                                
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.notas.id }   
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.notas.name }
                                    rows=       { confPantalla.largeinv.controles.modaleditlinea.notas.rows }      
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.notas.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.notas.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.notas.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.notas.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.notas.readonly }                                                
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.notas.disabled }
                                    change=     { e => handleInputModal(e, saveNotasLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasEnLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.largeinv.controles.modaleditlinea.notas_en.id }   
                                    name=       { confPantalla.largeinv.controles.modaleditlinea.notas_en.name }
                                    rows=       { confPantalla.largeinv.controles.modaleditlinea.notas_en.rows }      
                                    label=      { confPantalla.largeinv.controles.modaleditlinea.notas_en.label }                                                       
                                    placeholder={ confPantalla.largeinv.controles.modaleditlinea.notas_en.placeholder }    
                                    col=        { confPantalla.largeinv.controles.modaleditlinea.notas_en.col } 
                                    required=   { confPantalla.largeinv.controles.modaleditlinea.notas_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.largeinv.controles.modaleditlinea.notas_en.readonly }                                                
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.largeinv.controles.modaleditlinea.notas_en.disabled }
                                    change=     { e => handleInputModal(e, saveNotasEnLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditLinea }
                                        disabled={ docBloqueado == true ? true : false}                                        
                                >
                                    {confPantalla.largeinv.controles.modaleditlinea.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditLinea(false) }                                        
                                >
                                    {confPantalla.largeinv.controles.modaleditlinea.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                </section>
            </div>
            <Footer />
        </div>
    );

}
export default LargeInv